import React, { Component } from 'react';

class LabelDatosEmpresa extends Component {
    constructor(props) {
        super(props);
    }

    render () {
        let labelDocumentoEmpresa;
        let documento = this.props.data.GET_DOCUMENTO;
        let denominacion;
        let categoria;
        if (!this.props.data.errorEnWebServiceDocumento) {
            denominacion = this.props.data.GET_DOCUMENTO.nombreEmpresa;
            categoria = this.props.data.GET_DOCUMENTO.categoriaIva;
        
            labelDocumentoEmpresa = <div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Denominación de la empresa (para los archivos)</label>
                    </div>
                    <div>
                        <label className="label-secondary">{denominacion}</label>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Tipo de IVA</label>
                    </div>
                    <div>
                        <label className="label-secondary">{categoria}</label>
                    </div>
                </div>
            </div>
        }
        else {
            denominacion = this.props.data.GET_DOCUMENTO;

            labelDocumentoEmpresa = <div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Denominación de la cuenta (para los archivos)</label>
                    </div>
                </div>
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Tipo de IVA</label>
                    </div>
                </div>
                <div className="col-xs-12">
                    <div>
                        <label className="alert-danger">{denominacion}</label>
                    </div>
                </div>
            </div>
        }

        //if (this.props.data != undefined && this.props.data != "") {
        //    denominacion = this.props.data.GET_CLIENTE[0].Nombre + " " + this.props.data.GET_CLIENTE[0].Apellido;
        //    categoria = this.props.data.GET_CLIENTE[0].CATEGORIA;
        //}

        return (
            <div className="row top-separator-xs">
                {labelDocumentoEmpresa}
            </div>
        );
    }
};

export default LabelDatosEmpresa;